<template>
    <div id="app">
        <router-view style="flex: 1;overflow: hidden;display: flex;" />
    </div>
</template>

<script>
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import mapState2 from "@/util/vuexExt.js";

export default ({
    computed: {
        ...mapState2(["C_终端序列号"]),
    },
    created() {
        //强制网址后面带index.html,避免CDN对根目录(http://domain.com/)刷新太慢
        if ((window.location.pathname || '').endsWith('/')) window.location.pathname += 'index.html';
        if (window.location.query('isdebug')) window.isdebug = window.location.query('isdebug');
    },
    async mounted() {
        try {
            this.获取浏览器指纹();
        } catch (error) {
            this.$Alert(error);
        }
    },
    methods: {
        async 获取浏览器指纹() {
            try {
                // 1. 初始化实例
                const fpInstance = await FingerprintJS.load({
                    monitoring: false, // 关闭指纹变化监控（减少性能消耗）
                    // 可选：启用更多特征（默认已包含Canvas、WebGL等）
                    // features: { canvas: true, webgl: true }
                });
                // 2. 获取指纹结果
                const result = await fpInstance.get();

                // 3. 存储结果
                this.C_终端序列号 = result.visitorId; // 唯一指纹ID
                //this.confidenceScore = result.confidence.score; // 置信度

                console.log('浏览器指纹结果：', result, this.C_终端序列号);
            } catch (err) {
                console.error('❌️指纹获取异常：', err);
            }
        }
    }
});
</script>

<style lang="scss">
html,
body {
    width: 100%;
    height: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    background: whitesmoke;
    color: #2c3e50;

    text-align: left;
    height: 100%;
    width: 100%;
    display: flex;

    overflow: hidden;
}

ul {
    margin: 0;
    padding: 0;

    li {
        list-style: none;
    }
}
.tablegrouprow {
    tbody > tr > .el-table__row {
        background: lightgray;
    }
}
.myeltable-expanded-nopadding .el-table__expanded-cell {
    padding: 0;
}

.myeltable-expanded-nopadding .el-table__expanded-cell[class*="cell"] {
    padding: 0 !important;
}
.longtext {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.delete {
    text-decoration: line-through;
    color: #aaa;
    > * {
        color: #aaa;
    }
}
.refund {
    color: red;
    > * {
        color: red;
    }
}

.flex-warp {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 0 0 10px !important;

    > * {
        margin: 0 10px 10px 0 !important;
    }
}

.row {
    display: flex;
    flex-direction: row;
}
.row-flex {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    > * {
        flex: 1;
    }
}
</style>


<style>
.childs-margin-right10 > * {
    margin-right: 10px !important;
}
.childs-margin-bottom10 > * {
    margin-bottom: 10px !important;
}

.popperclass {
    min-width: 179px !important; /* 最小宽度179px */
    width: auto !important; /* 宽度自适应内容 */
}

/* 去掉number输入框的上下箭头 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
input[type="number"] {
    -moz-appearance: textfield;
}

/* 解决输入中文后光标上移的问题 */
.el-input__inner {
    line-height: 1px !important;
}

.el-autocomplete-suggestion li.highlighted {
    background-color: #92b5ea !important;
}

.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
    background-color: #92b5ea !important;
}

.el-table__body tr.hover-row.current-row > td.el-table__cell,
.el-table__body
    tr.hover-row.el-table__row--striped.current-row
    > td.el-table__cell,
.el-table__body
    tr.hover-row.el-table__row--striped.selection-row
    > td.el-table__cell,
.el-table__body tr.hover-row.el-table__row--striped > td.el-table__cell,
.el-table__body tr.hover-row.selection-row > td.el-table__cell,
.el-table__body tr.hover-row > td.el-table__cell {
    background-color: #92b5ea !important;
}
</style>